import React, { Component, PropTypes } from 'react';
import RulerBar from 'components/RulerBar';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import DiscountStore from 'stores/Discount';
import AppPage from 'components/AppPage';
import DiscountActions from 'actions/Discount';
import {
  TextField,
  Dialog,
  FlatButton,
  FloatingActionButton
} from 'material-ui';
import Message from 'services/Message';
import ListDetail from 'components/Material/ListDetail';
import DiscountDetail from 'components/Route/Discount/Detail';
import * as SvgIcons from 'components/Material/SvgIcons';

let { ContentAdd } = SvgIcons;

export default class Discounts extends mixin(
  RefluxMixin,
  Authorizer,
  Component
) {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  state = {
    valid: false,
    errorText: null
  };

  /**
   * Listen to the DiscountStore and AppStore
   *
   */
  listenToStores() {
    this.listenToStore(DiscountStore, 'discount');
  }

  /**
   * Listen to actions and update state as needed
   */
  listenToActions() {
    this.listenToAction(DiscountActions.genericError, this.onError.bind(this));
  }

  /**
   * Display error through the Message Service.
   *
   * @param  {string} errorMessage Error message to display
   */
  onError(errorMessage) {
    Message.info(errorMessage);
  }

  /**
   * Read all discounts on mount
   */
  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    DiscountActions.read();
  }

  /**
   * Select a particular discount. This will result in the details of this discount
   * to be displayed. If the current selected discount is different than the already
   * selected one, also invoke an action.
   *
   * @param  {object} discount Discount to select
   */
  gotoDiscount(discount) {
    this.props.router.push(`/discount/${discount.id}`);
    DiscountActions.read();
  }

  /**
   * Display a dialog for creating a new discount
   */
  addDiscountForm() {
    this.refs.createDialog.show();
  }

  /**
   * Confirms the creation of a discount and invokes the proper action
   * @return {[type]} [description]
   */
  onConfirmCreate() {
    const code = this.refs.discountName.getValue();
    if (code && code !== '' && code.length <= 30) {
      this.refs.createDialog.dismiss();
      DiscountActions.create({
        code,
        discount: 1,
        maxCount: '0',
        active: true
      });
    } else {
      Message.info(this.context.getIntlMessage('discount.codeRestriction'));
    }
  }

  handleChange = event => {
    const { getIntlMessage } = this.context;
    const { value } = event.target;
    if (value.length <= 30) {
      this.setState({
        errorText: !value && getIntlMessage('discount.codeRequired'),
        valid: !!value
      });
    } else {
      Message.info(this.context.getIntlMessage('discount.codeRestriction'));
    }
  };

  render() {
    let discounts = this.state.discount.list;
    const { errorText, valid } = this.state;
    let detail;
    let standardActions = [
      <FlatButton
        disabled={!valid}
        key="ok"
        label={this.context.getIntlMessage('Create')}
        secondary={true}
        className="full"
        onTouchTap={this.onConfirmCreate.bind(this)}
      />
    ];
    return (
      <AppPage
        header={
          <RulerBar title={this.context.getIntlMessage('menu.Discounts')} />
        }
        className={'discounts'}
      >
        <ListDetail
          items={discounts}
          labelProperty="code"
          onTouchTapItem={this.gotoDiscount.bind(this)}
          hasDivider={false}
          floatingActionButton={
            <FloatingActionButton onTouchTap={this.addDiscountForm.bind(this)}>
              <ContentAdd />
            </FloatingActionButton>
          }
        >
          {this.props.children}
        </ListDetail>

        <Dialog
          ref="createDialog"
          title={this.context.getIntlMessage('discount.new')}
          actions={standardActions}
          dismissOnClickAway={true}
        >
          <TextField
            onChange={this.handleChange}
            errorText={errorText}
            ref="discountName"
            fullWidth={true}
            hintText={this.context.getIntlMessage('discount.enterCode')}
            floatingLabelText={this.context.getIntlMessage('discount.code')}
          />
        </Dialog>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Discounts.js